<div class="card3dsecure-header" [ngClass]="{'ie11': isIE11}">
  <card3dsecure-app-header></card3dsecure-app-header>
</div>
<div class="card3dsecure-frame-content-wrapper {{brand}}" [ngClass]="{'ie11': isIE11}">
    <div class="card3dsecure-main-content-wrapper">
        <div class="card3dsecure-frame-content">
            <router-outlet (window:unload)="doUnload()"></router-outlet>
        </div>
        <!-- <card3dsecure-app-footer class="footer"></card3dsecure-app-footer> -->
    </div>
</div>
<session-timeout-warning></session-timeout-warning>
<loading-mask></loading-mask>
